var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.ticketAssigned", {
            user1: _vm.getActorName(),
            user2: _vm.$_.get(_vm.activity, "payload.assignedUserName"),
          })
        ),
      },
    }),
    _vm._v(" "),
    _vm.$_.get(_vm.activity, "payload.ticketSubject")
      ? _c("span", { staticClass: "quote" }, [
          _vm._v(
            "\n            Ticket subject =\n            " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.ticketSubject")) +
              "\n        "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }